{
  "translation": {
    "title": "Croisière Varo",
    "greeting": "Salut, {{name}}!"
  }
}
